import type { FC } from 'react';
import { Box } from '../Box';

export interface DynamicYieldProps {
  dataDyId?: string;
  margin?: string;
  padding?: string;
}

export const DynamicYield: FC<DynamicYieldProps> = ({
  dataDyId = 'empty',
  margin,
  padding,
}): JSX.Element => (
  <Box
    data-dy={dataDyId}
    sx={[
      Boolean(margin) && {
        margin,
      },
      Boolean(padding) && {
        padding,
      },
    ]}
    data-testid="dy"
  />
);
